// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import Layout from '../components/Layout';
import TextHeader1 from '../components/TextHeader1';
import TextStrong from '../components/TextStrong';
import ListItemMerchant from '../components/ListItemMerchant';
import InputCCAccountNumber from '../components/InputCCAccountNumber';
import InputGeneralAccountNumber from '../components/InputGeneralAccountNumber';
import Container from '../components/Container';
import ButtonBlock from '../components/ButtonBlock';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import type { TProps } from './types';


function Form(props: TProps): React.Node {
  const { merchant, mask, success_next_path_state } = props.navigation.current.state;
  const [number, setNumber] = React.useState('');
  const [submitAttempted, setSubmitAttempted] = React.useState(false);
  const [error, setError] = React.useState('');

  const onSubmit = () => {
    setSubmitAttempted(true);
    const account_number = merchant.isTypeCC() ? number : [number, mask].filter(Boolean).join('');

    if (number.trim() === '') return setError('Enter a valid account number');

    props.setIsLoading(true);
    props
      .asyncLinkAccount({
        mch_id: merchant.mch_id,
        account_number,
        public_plaid_account_token: success_next_path_state
          ? success_next_path_state.public_plaid_account_token
          : null,
      })
      .then(data => {
        const additional_state = success_next_path_state || {};
        props.navigateTo('/results', { merchant, data, ...additional_state });
      })
      .catch((error) => {
        props.dispatchEvent(EVENT_TYPES.error, error.toObject());
        props.navigateTo('/results', { merchant, error, data: {} })
      })
      .finally(() => {
        props.setIsLoading(false);
        setSubmitAttempted(false);
      });
  };

  const inputProps = {
    merchant,
    mask,
    onChange: setNumber,
    error: (submitAttempted && error) ? error : null,
  };

  return (
    <Layout {...props} showLogo showBack showExit padded>
      <Container mb={16} relative left={-24} width="100vw">
        <ListItemMerchant mask={mask} merchant={merchant} />
      </Container>
      <Container>
        <Container mb={22}>
          <TextHeader1>
            <TextStrong extra>
              {merchant.getPresentableInputPrompt(mask)}
            </TextStrong>
          </TextHeader1>
        </Container>
        <Container mb={22}>
          {merchant.isTypeCC()
            ? <InputCCAccountNumber {...inputProps} />
            : <InputGeneralAccountNumber {...inputProps} />}
        </Container>
        <ButtonBlock primary onClick={onSubmit}>Submit</ButtonBlock>
      </Container>
    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(Form, { name: 'Form' });
